export const MessageIcon = () => (
  <svg height="59" viewBox="0 0 59 59" width="59" xmlns="http://www.w3.org/2000/svg">
    <g data-name="Group 4065" id="Group_4065" transform="translate(5625 4310)">
      <circle
        cx="29.5"
        cy="29.5"
        data-name="Ellipse 1559"
        fill="#e9f2ff"
        id="Ellipse_1559"
        r="29.5"
        transform="translate(-5625 -4310)"
      />
      <path
        d="M25.992,5.625H4.749a2.506,2.506,0,0,0-2.5,2.5v15.62a2.506,2.506,0,0,0,2.5,2.5H25.992a2.506,2.506,0,0,0,2.5-2.5V8.124A2.506,2.506,0,0,0,25.992,5.625Zm-.312,5.311L15.371,17.808,5.062,10.936v-2.5l10.309,6.873L25.68,8.437Z"
        data-name="Icon ionic-md-mail"
        fill="#7ea5dd"
        id="Icon_ionic-md-mail"
        transform="translate(-5610.718 -4296.569)"
      />
    </g>
  </svg>
);
